// @ts-check

import { i18n } from '@/i18n'
import { useStorage } from '@vueuse/core'
import { defineStore } from 'pinia'
import { useStore } from 'vuex'

export const useLanguageStore = defineStore('language', () => {
  const store = useStore()

  const language = useStorage('language', 'fi')

  /** @param {Locale} newLanguage */
  const changeLanguage = async (newLanguage) => {
    language.value = newLanguage
    i18n.global.locale.value = newLanguage
    await store.dispatch('mobileData/setMobileWrapperLanguage', newLanguage)
  }

  return {
    language,
    changeLanguage,
    $reset: () => true
  }
})

export default useLanguageStore
